import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const VETERAN_CAR = {
  nickname: 'PRODUCTS.VETERAN_CAR.shortname',
  properties: [
    {
      name: 'productPackage', key: 'PRODUCT_PACKAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.ANSVAR', value: 'ANSVAR' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.DELKASKO', value: 'DELKASKO' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.KASKO', value: 'KASKO' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.BRANN_TYVERI', value: 'BRANN_TYVERI' },
        ]
      }
    },
    {
      name: 'vehicleLicenseNumber', key: 'LICENSE_NUMBER', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.STRING,
      VETERAN_CAR: true,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'tffVehicleBrand', key: 'TFF_VEHICLE_BRAND', group: 'OBJECT_INFO' },
    {
      name: 'parkingInGarage', key: 'PARKING_IN_GARAGE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'vehicleWinterUsage', key: 'VEHICLE_WINTER_USAGE_VETERAN_CAR', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'vehicleYoungDriver', key: 'YOUNG_DRIVER', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'vehicleRescue', key: 'VEHICLE_REDNING', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'vehicleDrivingLengthReadingKm', key: 'DRIVING_LENGTH_READING_KM', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.NUMBER,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'vehicleDrivingLengthReadingDate', key: 'DRIVING_LENGTH_READING_DATE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.DATE,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        dateView: 'month'
      }
    },
    { name: 'ofvFirstTimeRegYear', key: 'OFV_FIRST_TIME_REG_YEAR', group: 'OBJECT_INFO' },
    {
      name: 'calculatedClientAge', key: 'CLIENT_AGE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.required,
        Validators.pattern(/^\d+$/)
      ]]
    },
    { name: 'tffVehicleTaxCode', key: 'TFF_VEHICLE_TAX_CODE', group: 'OBJECT_INFO' },
    { name: 'tffVehicleChassisNumber', key: 'TFF_VEHICLE_CHASSIS_NUMBER', group: 'OBJECT_INFO' },
    {
      name: 'vehicleType', key: 'VEHICLE_TYPE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.VEHICLE_TYPE.CAR', value: 'CAR' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.VEHICLE_TYPE.MOPED', value: 'MOPED' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.VEHICLE_TYPE.MOTORCYCLE', value: 'MOTORCYCLE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.VEHICLE_TYPE.TRACTOR', value: 'TRACTOR' },
        ]
      }
    },
    {
      name: 'vehicleDriverAccident', key: 'VEHICLE_DRIVER_ACCIDENT', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'productSumInsured', key: 'SUM_INSURED_VETERAN_CAR', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.NUMBER,
      validator: ['', [
        Validators.required
      ]]
    },
  ],
  icon: 'veteran-car'
};
